var Component = require("!../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./tag.vue"),
  /* template */
  require("!!../../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-79cbbc77!../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./tag.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/select/src/dependencies/packages/tag/src/tag.vue
// module id = 569
// module chunks = 0